import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { FooterNavProps } from './FooterNav';

export interface FooterSectionProps {
  className?: string;
  leftSection?: ReactElement<FooterNavProps>;
  rightSection?: ReactElement<FooterNavProps>;
  secondary?: boolean;
}

const FooterSection = ({ leftSection, rightSection, className, secondary }: FooterSectionProps): JSX.Element => {
  const footerClasses = classNames(
    className,
    'ver-footer__section',
    'grid-container',
    secondary ? 'ver-footer--secondary' : 'ver-footer--primary',
  );

  return (
    <div className={footerClasses}>
      {leftSection}
      <span className="ver-footer--right">{rightSection}</span>
    </div>
  );
};

export default FooterSection;
